import { ROW_TYPE, TABLE_MODE } from '../../../../../../constants/generalConstants';
import { TableModeType, TableBlockRowCellType, RowContentType, CellMetadataType } from '../../../../../../types';
import createColorGradient from '../../../../../../utils/colorGradients';

const getColorFromConfidence = createColorGradient();

type GetAnnotationTableCellStylingReturnType = {
    styles: Record<string, string>;
    classes: string;
};

export const getAnnotationTableCellStyling = (
    mode: TableModeType,
    cell: TableBlockRowCellType,
    rowContentType: RowContentType,
    cellMetadata: CellMetadataType,
    importCandidate: boolean
): GetAnnotationTableCellStylingReturnType => {
    const styles: Record<string, string> = {};

    if (mode === TABLE_MODE.NORMAL) {
        styles['--confidence-color'] = getColorFromConfidence(cell.confidence);
    }

    let classes = '';

    if (styles['--confidence-color']) {
        classes = `${classes} confidence`;
    }

    if (mode === TABLE_MODE.DATA_TYPE && cellMetadata) {
        classes = `${classes} ${cellMetadata.dataType}`;
    }

    if (rowContentType !== ROW_TYPE.FINANCIAL_DATA && mode === TABLE_MODE.NORMAL) {
        classes = `${classes} non-financial-data`;
    }

    if (!importCandidate) {
        classes = `${classes} non-import-candidate`;
    }

    return {
        styles,
        classes,
    };
};
